import { useEffect } from 'react';

import styled from '@emotion/styled';
import { MenuSectionItem, Typography } from '@kc-console/common-ui';
import { useServiceAppState } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import { useRefinedConsoleMenuState, useSearchedMenus } from '../../../../hooks';
import { ALL_CATEGORY } from '../../../../stores';
import { useSearchPopover } from './SearchPopoverProvider';
import SearchResultMenuItem from './SearchResultMenuItem';

const SearchResults = () => {
  const { t } = useTranslation();
  const { inputValue, focusedIndex, setTotalItems } = useSearchPopover();
  const { allServices } = useRefinedConsoleMenuState({ isSearchable: true });
  const {
    state: { region },
  } = useServiceAppState();

  const title = t('layout:search.result.region_all', { region });
  const searchedMenus = useSearchedMenus(allServices, inputValue, ALL_CATEGORY);

  useEffect(() => {
    setTotalItems(searchedMenus.length);
  }, [searchedMenus.length, setTotalItems]);

  return (
    <MenuSectionItem title={title} expanded>
      <OptionItemListContainer tabIndex={-1}>
        {searchedMenus.length > 0 &&
          searchedMenus.map((menu, idx) => (
            <SearchResultMenuItem
              key={menu.name}
              menu={menu}
              keyword={inputValue}
              index={idx}
              focused={focusedIndex === idx}
            />
          ))}
        {searchedMenus.length === 0 && (
          <NoSearchResultText variant={'label/regular/md'}>
            {t('layout:search.result.no_result', { keyword: inputValue })}
          </NoSearchResultText>
        )}
      </OptionItemListContainer>
    </MenuSectionItem>
  );
};

const NoSearchResultText = styled(Typography)`
  font-size: 14px;
  padding: 10.5px 20px;
  color: #878e9b;
`;

const OptionItemListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  max-height: 280px;
  overflow-y: auto;
  overflow-wrap: break-word;
`;

export default SearchResults;
